"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoControls = void 0;

var _react = _interopRequireWildcard(require("react"));

var _VideoController = require("./controllers/VideoController");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var useVideoControls = function useVideoControls(ref) {
  var controller = null;

  if (ref) {
    controller = _VideoController.VideoController.getInstance(ref.current);
  }

  var play = function play() {
    if (controller) {
      controller.onPlay();
    } else {
      document.dispatchEvent(new CustomEvent("trc-play"));
    }
  };

  var pause = function pause() {
    if (controller) {
      controller.onPause();
    } else {
      document.dispatchEvent(new CustomEvent("trc-pause"));
    }
  };

  var jump = function jump(to) {
    if (controller) {
      controller.onJump({
        detail: to
      });
    } else {
      document.dispatchEvent(new CustomEvent("trc-jump", {
        detail: to
      }));
    }
  };

  var jumpForward = function jumpForward() {
    var amt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

    if (controller) {
      controller.onJumpForward({
        detail: amt
      });
    } else {
      document.dispatchEvent(new CustomEvent("trc-jump-forward", {
        detail: amt
      }));
    }
  };

  var jumpBack = function jumpBack() {
    var amt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

    if (controller) {
      controller.onJumpBackward({
        detail: amt
      });
    } else {
      document.dispatchEvent(new CustomEvent("trc-jump-back", {
        detail: amt
      }));
    }
  };

  var toggleMulticam = function toggleMulticam(e) {
    if (controller) {
      controller.toggleMulticam(e);
    } else {
      document.dispatchEvent(new CustomEvent("trc-multicam-toggle"));
    }
  };

  var selectCamera = function selectCamera(camera) {
    if (controller) {
      controller.selectCamera(camera);
    } else {
      console.warn("container ref is required to select camera");
    }
  };

  return {
    play: play,
    pause: pause,
    jump: jump,
    jumpForward: jumpForward,
    jumpBack: jumpBack,
    toggleMulticam: toggleMulticam,
    selectCamera: selectCamera,
    videoController: controller
  };
};

exports.useVideoControls = useVideoControls;